<template>
  <v-card outlined class="app-card">
    <v-card-title class="app-card-title mb-0"> Menu </v-card-title>
    <v-card-text class="app-card-content pl-0 pr-0 pb-0">
      <v-list nav dense>
        <v-list-item-group color="primary">
          <v-list-item :to="{ name: 'renovacao-registro-veiculo' }" exact>
            <v-list-item-icon>
              <v-icon v-text="'assignment'" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Renovação Registro de Veículo'" />
            </v-list-item-content>
          </v-list-item>
          <v-list-item :disabled="!checkTypeService" :to="{ name: 'inclusao-veiculo' }" exact>
            <v-list-item-icon>
              <v-icon v-text="'assignment'" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :disabled="!checkTypeService" v-text="'Inclusão de Veículo'" />
            </v-list-item-content>
          </v-list-item>
          <v-list-item :disabled="!checkTypeService" :to="{ name: 'exclusao-veiculo' }" exact>
            <v-list-item-icon>
              <v-icon v-text="'assignment'" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title :disabled="!checkTypeService" v-text="'Exclusão de Veículo'" />
            </v-list-item-content>
          </v-list-item>
          <v-list-item :disabled="!checkTypeService" :to="{ name: 'renovacao-transportadora' }" exact>
            <v-list-item-icon>
              <v-icon v-text="'assignment'" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Renovação Transportadora' " />
            </v-list-item-content>
          </v-list-item>
          <v-list-item :disabled="!isComplementar" :to="{ name: 'substituicao-cooperado' }" exact>
            <v-list-item-icon>
              <v-icon v-text="'assignment'" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Substituição de Cooperado'" />
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'pedidos-list' }" exact>
            <v-list-item-icon>
              <v-icon v-text="'assignment_return'" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'Pedidos'" />
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider class="mt-8 mb-3" />
      <a :href="urlWiki" class="help" target="_blank">
        <v-icon slot="icon" size="20">infor</v-icon>
        <span>Ajuda</span>
      </a>
    </v-card-text>
  </v-card>
</template>

<script>
import { VUE_APP_WIKI_RENOVACAO_VEICULO_URL } from '@/commons/config';
import VeiculoService from '@/services/sit-pedidos/veiculo.service';
import { mapState } from 'vuex';
export default {
  name: 'Menu',
  data: () => ({
    urlWiki: VUE_APP_WIKI_RENOVACAO_VEICULO_URL,
    checkTypeService: false,
    isComplementar: false,
  }),
  computed: {
    ...mapState('transportadora', ['transportadora']),
  },
  methods: {
    getTipoServico() {
      const { id } = this.transportadora;
      VeiculoService.getTipoServicoTransportadora(id).subscribe(
        res => {
          this.checkTypeService = res.some(ts => ts.descricao == 'Fretamento');
          this.isComplementar = res.some(ts => ts.descricao == 'Complementar');
        },
        err => {
          this.checkTypeService = false;
          this.isComplementar = false;
          console.error('Erro ao buscar tipo de serviço:', err);
        }
      );
    },
  },
  mounted() {
    this.getTipoServico();
  },
};
</script>

<style lang="scss" scoped>
.help {
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  justify-content: center;
  color: #333;

  i {
    color: #333;
  }

  span {
    margin-left: -16px;
  }
}
</style>
